/**
 * ADGMQ
 * imedia
 *
 * Register form
 */

import $ from 'jquery';
import validate from 'jquery-validation';

jQuery.validator.addMethod(
  'phoneUS',
  function(phone_number, element) {
    return (
      this.optional(element) ||
      (phone_number.length > 9 &&
        phone_number.match(/^[2-9]\d{2}\s+[2-9]\d{2}\-\d{4}/))
    );
  },
  'Please specify a valid phone number',
);

jQuery.validator.setDefaults({
  ignore: [],
});

(function($) {
  if ($('body').hasClass('page-template-template-profile')) {
    var elem = window.location.hash.replace('#', '');

    if (elem) {
      $('body, html').animate(
        {
          scrollTop: $('#' + elem).offset().top,
        },
        200,
      );
    }

    $("form[name='profile']").validate({
      rules: {
        field_405: {
          required: true,
          phoneUS: true,
        },
        field_256: {
          required: false,
          phoneUS: true,
        },
        field_419: {
          required: false,
          phoneUS: true,
        },
        field_464: {
          required: false,
          email: true,
        },
        new_password: {
          minlength: 8,
        },
        password_verification: {
          minlength: 8,
          equalTo: '#new_password',
        },
      },
      errorPlacement: function(error, element) {
        return true;
      },
      submitHandler: function(form) {
        form.submit();
      },
    });
  }
})(jQuery);
